import { useEffect, useState } from "react";
function useIsClient() {
    const [isClient, setIsClient] = useState(false);
    useEffect(()=>{
        setIsClient(true);
    }, []);
    return isClient;
}
const src_useIsClient = useIsClient;
export default src_useIsClient;
